/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import Webcam from "react-webcam";
import SystemCheckItem from "./SystemCheckItem";
import { FiChevronsRight } from "react-icons/fi";
import i18n from "../../../config/i18n";
import { withNamespaces } from "react-i18next";
function CheckAllowedMaterial(props) {
  const webcamRef = useRef(null);
  const onboardingProcess = props.information.session.onboardingProcess;
  const [info, setInfo] = useState({
    title: i18n.t("Checking_Materials"),
    ready: i18n.t("WAITING"),
    waitMessage: i18n.t("Please_wait_until_the_webcam_is_getting_ready"),
    description: <div className="d-flex flex-column" id="descriptionText" />,
    descriptionCover: "col-6",
    buttonText: i18n.t("Next_Step"),
  });
  const videoConstraints = {
    width: 1280,
    height: 720,
    deviceId: props.selectedDevice.video.deviceId,
  };

  useEffect(() => {
    const requirementPanel = document.getElementById("requirement_panel");
    requirementPanel.style.display = "none";
    const webcamPanel = document.getElementById("webcam_div");
    webcamPanel.classList.toggle("fixedHeight");
    webcamPanel.classList.toggle("singleFixedHeight");
  }, []);

  useEffect(() => {
    if (webcamRef.current) {
      if (
        onboardingProcess === "PROCTOR_ASSISTED" &&
        props.content !== "PREEXAM"
      ) {
        props.sendProctorSignalMessage("MATERIAL_SCAN", "Allowed Materials", 0);
      } else {
        webcamRef.current.video.oncanplay = () => {
          setInfo((info) => ({
            ...info,
            ready: i18n.t("OK"),
            waitMessage:
              i18n.t("Please_show_the_camera_the_materials_that_are_listed_below"),
          }));
        };
      }

      webcamRef.current.video.onsuspend = async () => {
        checkCurrentCameraState();
      };
    }
  }, [webcamRef]);

  useEffect(() => {
    checkCurrentCameraState();
    document.getElementById("requirement_panel").style.display = "none";
  }, []);

  const checkCurrentCameraState = async () => {
    let audioState = "HARDWARE_NOT_EXIST";
    try {
      await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: props.selectedDevice.video.deviceId,
        },
      });
      audioState = "OK";
    } catch (err) {
      audioState = "PERMISSION_DENIED";
    }
    if (audioState === "OK") {
    } else if (audioState === "HARDWARE_NOT_EXIST") {
      setInfo((info) => ({
        ...info,
        ready: i18n.t("FAILED"),
        waitMessage:
        i18n.t("No_webcam_detected_Please_plug_connect_a_webcam_and_repeat_the_system_check"),
      }));
    } else if (audioState === "PERMISSION_DENIED") {
      setInfo((info) => ({
        ...info,
        ready: i18n.t("FAILED"),
        waitMessage:
          i18n.t("Webcam_detected_but_the_permissions_are_denied_Please_check_your_Camera_Privacy_Settings"),
      }));
    }
  };

  const RenderRoomScanSubSteps = () => {
    return (
      <React.Fragment>
        <div
          style={{
            color: "rgba(141, 141, 142, 1)",
            fontSize: 14,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          {i18n.t("Please_show_the_materials_you_have_available_on_your_desk_in_front_of_you_for_example")}:
        </div>
        <div
          id="workspace_span"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Scrap_paper")}
        </div>
        <div
          id="over_and_under_check"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Pen_and_pencils")}
        </div>
        <div
          id="full_room_scan"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Calculators")}
        </div>
        <div
          style={{
            color: "rgba(141, 141, 142, 1)",
            fontSize: 14,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          {i18n.t("Or_any_personal_items_such_as")}:
        </div>
        <div
          id="ear_scan"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Medication")}
        </div>
        <div
          id="ear_scan"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Water_bottle")}
        </div>
        <div
          id="ear_scan"
          style={{
            color: "rgba(141, 141, 142, 0.7)",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <FiChevronsRight size={24} className="mr-3" />
          {i18n.t("Snacks_etc")}
        </div>
      </React.Fragment>
    );
  };

  return (
    <SystemCheckItem
      Icon={
        <React.Fragment>
          <div
            className="row h-100"
            style={{ backgroundColor: "rgba(255,255,255,1)" }}
          >
            {/* <div className="col-md-9 h-100"> */}
            <Webcam
              className="h-100"
              audio={false}
              ref={webcamRef}
              videoConstraints={videoConstraints}
            />
            {/* </div> */}
          </div>
          <div className="col-md-3 d-flex flex-column justify-content-center align-items-start ml-3">
            {RenderRoomScanSubSteps()}
          </div>
        </React.Fragment>
      }
      info={info}
      buttonHandler={props.buttonHandler}
      next={props.next}
      prev={props.prev}
      handleRepeatClick={props.handleRepeatClick}
      repeatableButton={true}
      configuration={props.configuration}
      currentStep={props.currentStep}
    />
  );
}
export default withNamespaces()(CheckAllowedMaterial)
